<template>
    <div
        class="select absolute z-10"
        v-if="show"
        @click="$emit('select', item)"
    >
        <span class="material-icons">
            {{ item.isAdded ? "check_circle" : "radio_button_unchecked" }}
        </span>
    </div>
</template>

<script>
export default {
    name: "MediaSelector",
    props: {
        item: {
            type: Object,
            required: true,
        },
        show: {
            type: Boolean,
            required: true,
        },
    },
};
</script>
